import React, { useEffect } from 'react';
import {
  SendForm,
  TitleContentLayout,
  SendStore,
  WalletStore,
  NamingAssetStore,
} from '@zen/common-app-parts';
import { Box, useModal, Modal, ModalContent } from '@zen-common/components-base';
import { useUnmountedRef } from '@zen/common-react-hooks';
import ConfirmWithdrawModalProcess from './components/ConfirmWithdrawModalProcess';

export default function Withdraw({ fields }) {
  const unmounted = useUnmountedRef();
  const { hide, show, isOpen } = useModal();
  const sendStore = SendStore.useStore();
  const [processStarted, setProcessStarted] = React.useState(false);
  const {
    actions: { fetchBalance },
  } = WalletStore.useStore();
  const { state: naming } = NamingAssetStore.useStore();

  useEffect(() => {
    fetchBalance().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // in case fields was provided, set it in the stores
  const sendStoreSetAddress = sendStore.actions.setAddress;
  React.useEffect(() => {
    if (fields) {
      sendStoreSetAddress(fields);
    }
  }, [fields, sendStoreSetAddress]);

  // close process when modal is closed
  React.useEffect(() => {
    if (!isOpen) {
      setProcessStarted(false);
    }
  }, [isOpen]);

  function cancelProcess() {
    hide();
  }

  function handleSendSuccess(success) {
    if (!unmounted.current && success) {
      sendStore.actions.reset();
      hide();
    }
  }

  const handleSubmit = async () => {
    setProcessStarted(true);

    show(() => (
      <Modal onDismiss={cancelProcess}>
        <ModalContent onClose={cancelProcess}>
          <ConfirmWithdrawModalProcess onCancel={cancelProcess} onFinish={handleSendSuccess} />
        </ModalContent>
      </Modal>
    ));
  };

  return (
    <TitleContentLayout title="Withdraw">
      <Box maxWidth="formsMaxWidth">
        <SendForm
          disabled={processStarted}
          sendStore={sendStore}
          onSubmit={handleSubmit}
          sendText="Withdraw"
          sendingText="Withdrawing..."
          naming={naming}
        />
      </Box>
    </TitleContentLayout>
  );
}
